import React, { useState } from 'react';
import { HexColorPicker } from "react-colorful";
import { useClickAway } from '@uidotdev/usehooks';
import styles from './CommonColorPicker.module.scss';

const PICKER_ID = `picker-${Math.random().toString().substring(2, 8)}`;
const CommonColorPicker = ({value, defaultValue='#FFFFFF', disabled = false, onChange, palette = [], paletteTitle = null, name, ...res}) => {

    const isControlled = value !== undefined;
    const [isOpen, setIsOpen] = useState(false);
    const [internalColor, setInternalColor] = useState(defaultValue);
    const color = isControlled ? value : internalColor

    const ref = useClickAway(() => {
        setIsOpen(false);
    });

    const handleOpenColorPicker = () => {
        if (isOpen === false) {
        setIsOpen(true);
        }
    };

    const handleChange = (newColor) => {
        if (!isControlled) {
        setInternalColor(newColor);
        }
        onChange?.(newColor);
    };

    return (<div className={styles['color-picker-wrapper']}>
        <div className={styles['color-picker-container']} {...res}>
            <input 
                className={`${styles['color-picker-input']} form-control`} 
                value={color} 
                onChange={(e) => {handleChange(e.target.value)}} onFocus={handleOpenColorPicker}
                disabled={disabled}
                name={name} />
            {
                !disabled &&
                <span className={styles['color-picker-span']} onClick={handleOpenColorPicker}>
                    <i style={{ backgroundColor: color }} />
                </span>
            }
            {isOpen && (
                <div className={styles.popover} ref={ref}>
                    <HexColorPicker color={color} onChange={handleChange} />
                    {palette?.length > 0 && <div className={styles['palette-wrapper']}>
                        <label>{paletteTitle || I18n.t('saved_colors')}:</label>
                        <div className={styles['palette-container']}>
                            {palette.map((paletteColor, i) => <div key={`${PICKER_ID}-${i}`} className={`${styles['palette-item-container']} ${color === paletteColor ? styles['selected'] : ''}`}>
                                <button
                                    style={{background: paletteColor}}
                                    className={styles['palette-item']}
                                    onClick={() => onChange?.(paletteColor)}
                                />
                            </div>)}
                        </div>
                    </div>}
                </div>
            )}
        </div>
    </div>)
}

export default CommonColorPicker;
